import React, { useRef, useEffect } from 'react';
import { Message } from '../../services/openai.service';
import UserMessage from './UserMessage';
import AgentMessage from './AgentMessage';

interface MessageListProps {
  messages: Message[];
  loading: boolean;
  profileImage?: string;
  onSendMessage: (cityName: string) => void;
  conversationId?: string | null;
  onShowContactCard?: () => void; // Callback para cuando se muestra la tarjeta de contacto
}

const MessageList: React.FC<MessageListProps> = ({ messages, loading = false, profileImage, onSendMessage, conversationId, onShowContactCard }) => {

  const messagesEndRef = useRef<HTMLDivElement>(null);

  // Función para formatear la fecha actual
  const formatTimestamp = (): string => {
    const now = new Date();
    return now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  // Efecto para hacer scroll al último mensaje
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);


  return (
    <div className="flex-1 overflow-y-auto hide-scrollbar p-4">
      {messages.map((message, index) => (
        <div key={index} className="mb-4">
          {message.role === 'user' ? (
            <UserMessage content={message.content} timestamp={formatTimestamp()} profileImage={profileImage} />
          ) : (
            <AgentMessage
              content={message.content}
              timestamp={formatTimestamp()}
              onSendMessage={onSendMessage}
              conversationId={conversationId}
              allMessages={messages} // Pasar todos los mensajes de la conversación
              onShowContactCard={onShowContactCard} // Pasar el callback para la tarjeta de contacto
            />
          )}
        </div>
      ))}

      {loading && (
        <div className="flex mb-4">
          <div className="w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center mr-2">
            <span className="text-sm font-bold text-xervix-primary">X</span>
          </div>
          <div className="bg-xervix-bg-secondary dark:bg-xervix-bg-secondary-dark text-xervix-text-primary dark:text-xervix-text-primary-dark p-3 rounded-tr-lg rounded-br-lg rounded-bl-lg">
            <div className="flex space-x-2">
              <div className="w-2 h-2 rounded-full bg-xervix-primary animate-bounce" style={{ animationDelay: '0ms' }}></div>
              <div className="w-2 h-2 rounded-full bg-xervix-primary animate-bounce" style={{ animationDelay: '300ms' }}></div>
              <div className="w-2 h-2 rounded-full bg-xervix-primary animate-bounce" style={{ animationDelay: '600ms' }}></div>
            </div>
          </div>
        </div>
      )}

      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;
